export default __webpack_public_path__ + "static/emvelope-3ce5aa36e5b1fdc66b5aabcc7ff5c882.webp";